import React, { useEffect, useState } from 'react';
import { ScrollView, TouchableOpacity, View } from 'react-native';
import { translate } from '../../../services/translate';
import MyAppText from '../../MyAppText';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import { centralAPI } from '../../../services/central-api';
import { InfoInRow } from '../../InfoInRow';
import { faCalendarCheck, faChevronDown, faChevronUp, faLocationDot } from '@fortawesome/pro-regular-svg-icons';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';

export default function OccurrenceFormSchoolApp({ occurrence }: { occurrence: Occurrence; }) {
    const { styles, theme } = useStyles(styleSheet);
    const [showDetails, setShowDetails] = useState<boolean>(false);
    const [address, setAddress] = useState<string>('');

    if (occurrence.triggerType != 'school_app' || !occurrence.externalReference) {
        return <></>;
    }

    async function fetchAddress(pos: LatLng) {
        const address = await centralAPI.getAddressByPlace({ latitude: pos.lat, longitude: pos.lng });
        if (address) {
            setAddress(address);
        }
    }

    useEffect(() => {
        fetchAddress({
            lat: occurrence.latitude,
            lng: occurrence.longitude
        });
    }, [occurrence]);

    return (
        <ScrollView contentContainerStyle={{ rowGap: 10 }}>
            <View style={{ gap: 5 }}>
                <MyAppText style={styles.text}>{translate('requester')}</MyAppText>
                {/* TODO: change when implemented school and director */}
                <MyAppText>{translate('name')}: { 'Alerta Escola Segura' }</MyAppText>
            </View>

            <View style={styles.generalInformation}>
                <TouchableOpacity
                    style={styles.generalInformationDropdown}
                    onPress={() => setShowDetails(!showDetails)}>
                    <MyAppText>{translate('general_info')}</MyAppText>
                    <FontAwesomeIcon icon={showDetails ? faChevronUp as IconDefinition : faChevronDown as IconDefinition} color={theme.colors.iconColor} />
                </TouchableOpacity>
                <View style={styles.tableLine}></View>
            </View>

            {showDetails ? <>
                <View style={{ gap: 3 }}>
                    <MyAppText style={styles.text}>{translate('location')}</MyAppText>
                    <>
                        <InfoInRow value={moment(new Date(occurrence.createdAt)).format('DD/MM/YYYY HH:mm:ss')} fontAwesomeIcon={faCalendarCheck}/>
                        <InfoInRow value={address} fontAwesomeIcon={faLocationDot}/>
                    </>
                </View></> : <></>}

        </ScrollView>
    );
}

const styleSheet = createStyleSheet((theme) => ({
    visualizedRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 5
    },
    detectionInfoText: {
        color: theme.colors.textColor,
        fontSize: 12
    },
    text: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 16
    },
    infoText: {
        color: theme.colors.textColor,
        fontWeight: 'bold',
        fontSize: 24
    },
    documentText: {
        fontFamily: 'Open Sans',
        color: theme.colors.textColor,
        fontSize: 14
    },
    tableLine: {
        borderBottomColor: theme.colors.card.border,
        borderBottomWidth: 1,
        flex: 1
    },
    generalInformation: {
        flexDirection: 'column',
        paddingHorizontal: 5,
        flex: 1,
        gap: 10
    },
    generalInformationDropdown: {
        flexDirection: 'row',
        gap: 10,
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1
    }
}));
